import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Custom element che mostra le varianti complementari del prodotto
 * e si aggiorna al cambio variante usando il section rendering di Shopify.
 */
class ComplementaryVariants extends Component {
  requiredRefs = ['list'];

  #abortController = null;

  connectedCallback() {
    super.connectedCallback();
    // Ascolta a livello document: la sezione del variant picker è in un'altra .shopify-section
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
    this.#abortController?.abort();
  }

  #handleVariantUpdate = async (event) => {
    const newVariant = event.detail?.resource;
    if (!newVariant?.id) return;

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const productUrl = this.dataset.productUrl;
    const sectionId = this.dataset.section;
    const url = `${productUrl}?variant=${newVariant.id}&section_id=${sectionId}`;

    try {
      const response = await fetch(url, { signal: this.#abortController.signal });
      if (!response.ok) return;

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newElement = doc.querySelector('complementary-variants');

      if (newElement) {
        morph(this, newElement);
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[complementary-variants] errore:', error);
      }
    }
  };
}

if (!customElements.get('complementary-variants')) {
  customElements.define('complementary-variants', ComplementaryVariants);
}